import { ProviderCreateDocumentType, SupportDocumentType } from '../../api';

export const MAX_BATCH_UPLOAD_FILES = 20;
export const DEFAULT_BATCH_UPLOAD_CONCURRENCY = 3;
export const DEFAULT_ACCEPTED_FILE_TYPES = 'application/pdf,image/*';

export type BatchUploadAppType = 'provider' | 'support';

export type UploadStatus = 'pending' | 'uploading' | 'success' | 'failed';

export interface FileUploadItem {
    id: string;
    file: File;
    status: UploadStatus;
    documentId?: string;
    errorMessage?: string;
}

export interface BatchUploadMetadata {
    documentType: ProviderCreateDocumentType | SupportDocumentType;
    description?: string;
    claimId?: string;
}

export interface BatchUploadStats {
    total: number;
    success: number;
    failed: number;
    pending: number;
    uploading: number;
}

export interface BatchUploadFormValues {
    files: File[];
    documentType: ProviderCreateDocumentType | SupportDocumentType | null;
    description?: string;
    claimId?: string;
}

export interface BatchUploadConfig {
    appType: BatchUploadAppType;
    maxFiles?: number;
    maxConcurrent?: number;
    acceptedTypes?: string;
}
